/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversations_Empty_BodyInputs */



/**
* | output |
* | --- |
* | "As soon as Wundo follows a conversation, it appears here — with the preparation, the report and the action items." |
*
* @param {Conversations_Empty_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const conversations_empty_body = /** @type {((inputs?: Conversations_Empty_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversations_Empty_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Zodra Wundo een gesprek opvolgt, staat het hier — met de voorbereiding, het verslag en de actiepunten.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dès que Wundo suit une conversation, elle apparaît ici — avec la préparation, le compte rendu et les points d'action.")
	return /** @type {LocalizedString} */ ("As soon as Wundo follows a conversation, it appears here — with the preparation, the report and the action items.")
});